import { render } from "./FederationPersonalData.vue?vue&type=template&id=2b8e2356&ts=true"
import script from "./FederationPersonalData.vue?vue&type=script&lang=ts"
export * from "./FederationPersonalData.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__